import { takeLatest, call, put } from "redux-saga/effects";
import {
    fetchLeaderInsightPromptsStart,
    fetchLeaderInsightPromptsSuccess,
    fetchLeaderInsightPromptsFail,
    fetchLeaderInsightPromptStart,
    fetchLeaderInsightPromptSuccess,
    fetchLeaderInsightPromptFail,
    reactToLeaderInsightDataModalStart,
    reactToLeaderInsightDataModalSuccess,
    reactToLeaderInsightDataModalFail,
    favouriteLeaderInsightPromptStart,
    favouriteLeaderInsightPromptSuccess,
    favouriteLeaderInsightPromptFail,
    setLeaderInsightGuestQuotaExceeded,
} from "../slices/leaderInsightSlice";
import { getRequest, postRequest } from "../../network";
import {
    LEADER_INSIGHT_PROMPTS,
    LEADER_INSIGHT_PROMPT_DETAIL,
    REACT_LEADER_INSIGHT_DATA_MODAL,
    FAVOURITE_LEADER_INSIGHT_PROMPT,
} from "../apis";

function* fetchLeaderInsightPromptsSaga(action) {
    try {
        const { leaderID, ...params } = action.payload;
        const url = LEADER_INSIGHT_PROMPTS.replace(":leaderID", leaderID);
        const response = yield call(getRequest, url, params);
        yield put(fetchLeaderInsightPromptsSuccess(response));
    } catch (error) {
        yield put(
            fetchLeaderInsightPromptsFail(
                error.response?.data?.message || error.message
            )
        );
    }
}

function* fetchLeaderInsightPromptSaga(action) {
    try {
        const { leaderID, promptID, personalityCombination } = action.payload;
        const url = LEADER_INSIGHT_PROMPT_DETAIL
            .replace(":leaderID", leaderID)
            .replace(":promptID", promptID);
        const response = yield call(getRequest, url, { personalityCombination });
        yield put(fetchLeaderInsightPromptSuccess(response));
    } catch (error) {
        if (
            error.response?.status === 403 &&
            error.response?.data?.quotaExceeded
        ) {
            yield put(
                setLeaderInsightGuestQuotaExceeded({
                    genericLeaderPromptsViewed:
                        error.response.data.genericLeaderPromptsViewed,
                    limit: error.response.data.limit,
                })
            );
            yield put(
                fetchLeaderInsightPromptFail(
                    error.response?.data?.message ||
                        "Guest prompt limit reached. Please log in to explore more."
                )
            );
            return;
        }
        if (
            error.response?.status === 403 &&
            error.response?.data?.requiresAssessment
        ) {
            yield put(
                fetchLeaderInsightPromptFail(
                    "Complete your assessment to unlock personalized prompts."
                )
            );
            return;
        }
        yield put(
            fetchLeaderInsightPromptFail(
                error.response?.data?.message || error.message
            )
        );
    }
}

function* reactToLeaderInsightDataModalSaga(action) {
    try {
        const { dataModalID, reaction } = action.payload;
        yield call(
            postRequest,
            REACT_LEADER_INSIGHT_DATA_MODAL.replace(":id", dataModalID),
            { reaction }
        );
        yield put(
            reactToLeaderInsightDataModalSuccess({ dataModalID, reaction })
        );
    } catch (error) {
        yield put(reactToLeaderInsightDataModalFail(error.message));
    }
}

function* favouriteLeaderInsightPromptSaga(action) {
    try {
        const { leaderID, promptID, favourite } = action.payload;
        const url = FAVOURITE_LEADER_INSIGHT_PROMPT
            .replace(":leaderID", leaderID)
            .replace(":promptID", promptID);
        const response = yield call(postRequest, url, { favourite });
        yield put(favouriteLeaderInsightPromptSuccess(response));
    } catch (error) {
        yield put(favouriteLeaderInsightPromptFail(error.message));
    }
}

export function* watchLeaderInsight() {
    yield takeLatest(
        fetchLeaderInsightPromptsStart.type,
        fetchLeaderInsightPromptsSaga
    );
    yield takeLatest(
        fetchLeaderInsightPromptStart.type,
        fetchLeaderInsightPromptSaga
    );
    yield takeLatest(
        reactToLeaderInsightDataModalStart.type,
        reactToLeaderInsightDataModalSaga
    );
    yield takeLatest(
        favouriteLeaderInsightPromptStart.type,
        favouriteLeaderInsightPromptSaga
    );
}
